import { useCallback } from 'react'
import classnames from 'classnames'
import { withRouter, withTranslate } from 'i18n/utils'

import Button from 'shared/components/Button'
import { CardSection } from 'shared/components/CardSection'
import { LocationCard } from 'shared/components/LocationCard'

import featureToggles from 'shared/featureToggles'
import isMobile from 'shared/responsive-helpers'

import { ButtonSwitch } from '@components/ButtonSwitch'

import { PURCHASE_FLOW } from 'subscription-flow/constants'
import { getSwitchButtons } from '@booking/utils'
import { SEARCH_MODE_EVENTS, SEARCH_MODE_MONTHLY, SEARCH_MODE_PREPAID, SEARCH_MODE_HOURLY } from 'search/constants'

import { MobileHeaderProgress } from './MobileHeaderProgress'

import styles from './styles.module.scss'

const PurchaseFlowHeader = ({
    grsId,
    activeStep,
    stepValues,
    locationName,
    translate: t,
    onStepClick,
    flowSteps = PURCHASE_FLOW,
    stepPrefix,
    parkingMode,
    defaultCustomerFlow,
    currentCustomerFlowType,
    onSwitchHourlyType,
    showOnlyBookInAdvanceFlow,
    history: { push },
}) => {
    const getStepValue = useCallback(
        (stepValues, stepIndex) => {
            const step = stepValues[stepIndex]
            let returnValue

            if (step) {
                returnValue =
                    Array.isArray(step) && step.length > 0
                        ? `${step.length} ${t('purchase.flow.header.label.selected')}`
                        : step.displayValue
                return <div className={classnames('mb-3', styles.stepValue)}>{returnValue}</div>
            }

            return null
        },
        [t]
    )

    const passedStep = index => index < flowSteps.indexOf(activeStep)
    const onClickSwitchTo = searchMode => {
        switch (searchMode) {
            case !featureToggles.caPurchaseFlow && SEARCH_MODE_HOURLY:
                push(`/booking/${grsId}`)
                break
            case !featureToggles.newSubscriptionFlow && SEARCH_MODE_MONTHLY:
                push(`/booking/${grsId}/subscriptions`)
                break
            case SEARCH_MODE_MONTHLY:
                push(`/subscription/${grsId}`)
                break
            case SEARCH_MODE_EVENTS:
                push(`/booking/${grsId}/events`)
                break
            case SEARCH_MODE_PREPAID:
            default:
                push(`/booking/${grsId}`)
                break
        }
    }

    const switchButtons = React.useMemo(
        () =>
            getSwitchButtons(
                defaultCustomerFlow,
                parkingMode,
                onClickSwitchTo,
                currentCustomerFlowType,
                onSwitchHourlyType,
                showOnlyBookInAdvanceFlow
            ),
        [defaultCustomerFlow, parkingMode, currentCustomerFlowType]
    )

    return (
        <CardSection className={styles.progressSection} loading={false}>
            {isMobile() && (
                <MobileHeaderProgress
                    getStepValue={getStepValue}
                    flowSteps={flowSteps}
                    activeStep={activeStep}
                    onStepClick={onStepClick}
                    passedStep={passedStep}
                    stepPrefix={stepPrefix}
                    t={t}
                    stepValues={stepValues}
                />
            )}
            <div className={classnames('d-flex', 'justify-content-between', 'align-items-start')}>
                <LocationCard locationName={locationName}></LocationCard>
                <Button btnStyle="link" onClick={() => window.location.assign('/')} className={styles.backHomeButton}>
                    <Link to="/">
                        <T>subscription.purchase.label.back.home</T>
                    </Link>
                </Button>
            </div>
            <div className={styles.eventSwitchButtons}>
                {switchButtons.length > 1 && (
                    <ButtonSwitch
                        className="mt-2"
                        btnStyle="purchaseView"
                        label={<T>booking.switch.label</T>}
                        buttons={switchButtons}
                    />
                )}
            </div>
            {!isMobile() && (
                <MobileHeaderProgress
                    getStepValue={getStepValue}
                    flowSteps={flowSteps}
                    activeStep={activeStep}
                    onStepClick={onStepClick}
                    passedStep={passedStep}
                    stepPrefix={stepPrefix}
                    t={t}
                    stepValues={stepValues}
                />
            )}
        </CardSection>
    )
}

export default compose(withRouter, withTranslate)(PurchaseFlowHeader)
